import {
  IpponBadge,
  IpponCard,
  IpponHSpace,
  IpponIcon,
  IpponText,
  IpponVSpace,
  IpponVSpaceSlot,
} from '@ippon-ui/react';

export const HistorySummaryLoadingComponent = () => (
  <IpponCard border>
    <IpponVSpace align="left" gap={16}>
      <IpponVSpaceSlot align="justify">
        <IpponHSpace gap={8} align={['space-between', 'middle']} wrap={true}>
          <IpponText tag="h4" variant="body" size="large" placeholder />
          <IpponHSpace gap={4} align="middle">
            <IpponIcon name="calendar" variant="outline" color="neutral-tertiary" size={16} />
            <IpponText
              variant="body"
              dataSelector="diagnostic.history.summary.date"
              placeholder
              color="neutral-tertiary"
            />
          </IpponHSpace>
        </IpponHSpace>
      </IpponVSpaceSlot>
      <IpponHSpace gap={8} align="middle" wrap={true}>
        <IpponBadge placeholder />
        <IpponBadge placeholder />
      </IpponHSpace>
      <IpponHSpace gap={16} align="middle" wrap={true}>
        <IpponText
          variant="body"
          size="large"
          color="neutral-tertiary"
          dataSelector="diagnostic.history.summary.cost"
          placeholder
        />
        <IpponText
          variant="body"
          size="large"
          color="neutral-tertiary"
          dataSelector="diagnostic.history.summary.duration"
          placeholder
        />
      </IpponHSpace>
    </IpponVSpace>
  </IpponCard>
);
